<template>
  <div class="setting-main-container" v-if="getBusinessPermission || userType=='super_admin'">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.rescheduling_restructuring.detail_rescheduling_restructuring') }}</h3>
        </div>
        <div class="row">
            <div class="col-md-12 mb-4">
                <label class="input-label">{{ $tc('profile.rescheduling_restructuring.rescheduling_restructuring') }}</label><span class="text-danger"> * </span>
                <p v-if="business && business.rescheduling_restructuring != null">{{ business.rescheduling_restructuring }}</p>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false,
      userType:null,
    }
  },
  watch: {
  },
  validations: {},
  computed: {
     ...mapGetters('business', [
      'business' ,
      'getBusinessPermission',
    ]),

  },
  created() {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    if(localStorage.getItem('role')=='super_admin' && this.business==null){
      this.getBusinessData();
    }
    this.checkBusinessPermission();

  },
  methods: {
    ...mapActions('business', [
      'addBusiness',
      'updateBusiness'
    ]),
    ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission',
      'fetchBusinessByUser'
    ]),
    checkBusinessPermission(){
      this.BusinessPermission(this.$route.params.id)
    },
    async getBusinessData(){
      let formData = {
        user_id: this.$route.params.id,
      }
      let  response = await this.fetchBusinessByUser(formData)
    }
  }
}
</script>
